import React from 'react';

const EnvTest = () => {
  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', margin: '20px' }}>
      <h3>Environment Variables Test</h3>
      <p><strong>NODE_ENV:</strong> {process.env.NODE_ENV}</p>
      <p><strong>REACT_APP_API_URL:</strong> {process.env.REACT_APP_API_URL}</p>
      <p><strong>REACT_APP_LINE_CLIENT_ID:</strong> {process.env.REACT_APP_LINE_CLIENT_ID}</p>
      <p><strong>All process.env:</strong></p>
      <pre style={{ backgroundColor: 'white', padding: '10px', fontSize: '12px' }}>
        {JSON.stringify(process.env, null, 2)}
      </pre>
    </div>
  );
};

export default EnvTest;